import { Amplify } from "aws-amplify";
import "@aws-amplify/auth";
import { type AuthEnvironment, getEnvironmentByKey } from "./auth-environments";
import { getSelectedEnvironment } from "./selected-environment";

/**
 * Configure Amplify Auth for a specific environment. When no key is given the
 * currently selected (persisted) environment is used, preserving single-set
 * behavior when only one environment is configured.
 */
export function configureAmplifyForEnvironment(envKey?: string): void {
  const env: AuthEnvironment =
    (envKey ? getEnvironmentByKey(envKey) : undefined) ??
    getSelectedEnvironment();

  if (env.cognitoUserPoolId && env.cognitoClientId) {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: env.cognitoUserPoolId,
          userPoolClientId: env.cognitoClientId,
          loginWith: {
            email: true,
            username: false,
            phone: false,
          },
        },
      },
    });
  } else {
    console.warn(
      "Cognito environment variables are not set. Authentication will not work.",
    );
  }
}

// Configure on import with the selected/default environment so existing
// side-effect imports keep working.
configureAmplifyForEnvironment();
